var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
let AbfragerQuestionAnswerPart = class AbfragerQuestionAnswerPart extends React.PureComponent {
    get opacity() {
        if (this.props.question.questionAppear.shouldBeVisible)
            return 1;
        return 0;
    }
    get transition() {
        if (this.props.question.questionAppear.shouldBeVisible)
            return 'opacity 0.25s ease-in';
        return '0.2s ease-out';
    }
    render() {
        const { question, children } = this.props;
        return (React.createElement(Actor_, { actor: question, key: question.id, structureTemplate: React.createElement("div", { "data-aspect": "answer", style: {
                    opacity: this.opacity,
                    transition: this.transition,
                    display: 'flex',
                    flex: '1 1 auto',
                    flexDirection: 'column'
                } }, children) }));
    }
};
AbfragerQuestionAnswerPart = __decorate([
    observer
], AbfragerQuestionAnswerPart);
export { AbfragerQuestionAnswerPart };
